import { render, staticRenderFns } from "./ClientInvoicesList.vue?vue&type=template&id=9ac58624&"
import script from "./ClientInvoicesList.vue?vue&type=script&lang=js&"
export * from "./ClientInvoicesList.vue?vue&type=script&lang=js&"
import style0 from "./ClientInvoicesList.vue?vue&type=style&index=0&id=9ac58624&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports